import { render, staticRenderFns } from "./WaveImage.vue?vue&type=template&id=5daf8dbd&scoped=true&"
import script from "./WaveImage.vue?vue&type=script&lang=js&"
export * from "./WaveImage.vue?vue&type=script&lang=js&"
import style0 from "./WaveImage.vue?vue&type=style&index=0&id=5daf8dbd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daf8dbd",
  null
  
)

export default component.exports